/* eslint-disable import/prefer-default-export */

export const seeNotesRequestValue = 'see_notes';



// WEBPACK FOOTER //
// ./src/compositions/CaseRequestsPanel/CaseRequestLines/BaseRequestLinesTable/constants.js